module.exports = {"id":"193549","name":"Shaun Hutchinson","rating":"72","photo":"./data/images/photos/1/193549.png","club":{"name":"Millwall","logo":"./data/images/clubs/Millwall.png"},"positions":["DC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ShaunHutchinson0.json
// module id = 3935
// module chunks = 0